import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names the way shadcn/ui components expect.
 *
 * twMerge resolves Tailwind conflicts so a caller's `className` wins over a
 * component's defaults (e.g. passing `p-0` beats a built-in `p-4`).
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
